import create from 'zustand';

// Dummy data for templates
const dummyTemplates = [
  {
    id: 1,
    name: 'Employment Contract',
    description: 'Standard employment contract template',
    createdAt: '2024-03-15',
    status: 'active',
    type: 'contract'
  },
  {
    id: 2,
    name: 'NDA Agreement',
    description: 'Non-disclosure agreement template',
    createdAt: '2024-03-14',
    status: 'active',
    type: 'agreement'
  },
  {
    id: 3,
    name: 'Invoice Template',
    description: 'Standard invoice template',
    createdAt: '2024-03-13',
    status: 'active',
    type: 'invoice'
  }
];

// Dummy data for completed forms
const dummyCompletedForms = [
  {
    id: 1,
    templateId: 1,
    templateName: 'Employment Contract',
    email: 'john.doe@example.com',
    date: '2024-03-15',
    status: 'completed'
  },
  {
    id: 2,
    templateId: 2,
    templateName: 'NDA Agreement',
    email: 'jane.smith@example.com',
    date: '2024-03-14',
    status: 'completed'
  }
];

// Dummy data for assigned forms
const dummyAssignedForms = [
  {
    id: 1,
    templateId: 1,
    templateName: 'Employment Contract',
    assignedTo: 'john.doe@example.com',
    assignedDate: '2024-03-15',
    dueDate: '2024-03-22',
    status: 'pending'
  },
  {
    id: 2,
    templateId: 2,
    templateName: 'NDA Agreement',
    assignedTo: 'jane.smith@example.com',
    assignedDate: '2024-03-14',
    dueDate: '2024-03-21',
    status: 'pending'
  }
];

// Dummy data for archive forms
const dummyArchiveForms = [
  {
    id: 1,
    templateId: 1,
    templateName: 'Employment Contract',
    email: 'john.doe@example.com',
    date: '2024-03-15',
    status: 'archived'
  },
  {
    id: 2,
    templateId: 2,
    templateName: 'NDA Agreement',
    email: 'jane.smith@example.com',
    date: '2024-03-14',
    status: 'archived'
  }
];

const useDocFormsStore = create((set) => ({
  // Templates state
  templates: dummyTemplates,
  setTemplates: (templates) => set({ templates }),
  addTemplate: (template) => set((state) => ({ 
    templates: [...state.templates, template] 
  })),
  removeTemplate: (id) => set((state) => ({
    templates: state.templates.filter(t => t.id !== id)
  })),

  // Completed forms state
  completedForms: dummyCompletedForms,
  setCompletedForms: (forms) => set({ completedForms: forms }),
  addCompletedForm: (form) => set((state) => ({
    completedForms: [...state.completedForms, form]
  })),
  removeCompletedForm: (id) => set((state) => ({
    completedForms: state.completedForms.filter(f => f.id !== id)
  })),

  // Assigned forms state
  assignedForms: dummyAssignedForms,
  setAssignedForms: (forms) => set({ assignedForms: forms }),
  addAssignedForm: (form) => set((state) => ({
    assignedForms: [...state.assignedForms, form]
  })),
  removeAssignedForm: (id) => set((state) => ({
    assignedForms: state.assignedForms.filter(f => f.id !== id)
  })),

  // Archive view state
  archiveForms: dummyArchiveForms,
  setArchiveForms: (forms) => set({ archiveForms: forms }),
  addArchiveForm: (form) => set((state) => ({
    archiveForms: [...state.archiveForms, form]
  })),
  removeArchiveForm: (id) => set((state) => ({
    archiveForms: state.archiveForms.filter(f => f.id !== id)
  })),
  // Loading state
  loading: false,
  setLoading: (loading) => set({ loading })
}));

export default useDocFormsStore; 